<template>
  <v-tab-item>
    <v-layout justify-space-between>
      <v-flex md2>
        <v-btn dark color="primary" @click.stop="showTemplateDialog()"><v-icon dark>add</v-icon>{{ $t('labelTemplate') }}</v-btn>
      </v-flex>
      <v-flex md2>
        <v-text-field
          append-icon="filter_list"
          class="text-xs-right"
          :label="$t('search')"
          single-line
          hide-details
          v-model="filter"
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="templateHeaders"
      :items="labelTemplates"
      item-key="key"
      class="my-1 levation-2 myDense"
      :rows-per-page-items="rowPerPage"
      :search="filter"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ businessTypeText(props.item.businessType) }}</td>
        <td class="text-xs-left">{{ props.item.from && props.item.from.fullName }}</td>
        <td class="text-xs-left">{{ props.item.to && props.item.to.fullName }}</td>
        <td class="text-xs-left">{{ shippingServiceText(props.item.shippingService, props.item.businessType) }}</td>
        <td class="text-xs-left">
          <v-layout align-center>
            <v-flex>
              <v-checkbox
                color="primary"
                @click.stop="setDefault(props.item)"
                :input-value="isDefaultTemplate(props.item)"
                :label="isDefaultTemplate(props.item) ? 'Default' : 'Un default'"
                hide-details
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </td>
        <td class="text-xs-center">
          <v-layout row>
            <v-flex>
              <v-btn dark flat color="primary" @click.stop="showTemplateDialog(props.item)">{{ $t('edit') }}</v-btn>
            </v-flex>
            <v-flex>
              <v-btn dark flat color="primary" @click.stop="deleteTemplate(props.item)">{{ $t('delete') }}</v-btn>
            </v-flex>
          </v-layout>
        </td>
      </template>
    </v-data-table>

    <LabelTemplatePopup
      v-model="createTemplateDialog"
      v-if="createTemplateDialog"
      :initTemplate="templateInEdit"/>
  </v-tab-item>
</template>

<script>
import { mapGetters } from 'vuex'
import LabelTemplatePopup from './LabelTemplatePopupForLabel.vue'

export default {
  name: 'LabelTemplateAdmin',
  components: {
    LabelTemplatePopup
  },
  data () {
    return {
      filter: '',
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      createTemplateDialog: false,
      templateInEdit: {},
      templateHeaders: [
        { text: this.$t('name'), value: 'name', align: 'left', sortable: false },
        { text: this.$t('shippingType'), value: 'businessType', align: 'left', sortable: false },
        { text: this.$t('senderName'), value: 'from.fullName', align: 'left', sortable: false },
        { text: 'Recipient', value: 'to.fullName', align: 'left', sortable: false },
        { text: this.$t('shippingService'), value: 'shippingService', align: 'left', sortable: false },
        { text: 'Default', value: 'isDefault', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '25%' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'labelTemplates',
      'labelTemplateDefaults',
      'shippingServices',
      'internationalLabelServices',
      'importToUSLabelServices'
    ])
  },
  methods: {
    showTemplateDialog (item = {}) {
      this.createTemplateDialog = true
      this.templateInEdit = item
    },
    deleteTemplate (item) {
      if (!confirm(this.$t('confirmDelete', { name: 'template' }))) return Promise.resolve()
      return this.$store.dispatch('deleteLabelTemplate', item)
    },
    setDefault (item) {
      const isCurrentDefault = this.isDefaultTemplate(item)
      return this.$store.dispatch('setLabelTemplateDefault', {
        businessType: item.businessType,
        templateId: isCurrentDefault ? '' : item.key
      })
    },
    shippingServiceText (shippingService, businessType) {
      if (!shippingService) return '-'
      const servicesByType = {
        export: this.internationalLabelServices,
        import: this.importToUSLabelServices,
        domestic: this.shippingServices
      }
      const source = servicesByType[businessType] || this.shippingServices || []
      const expanded = source.reduce((acc, service) => [
        ...acc,
        ...(service && Array.isArray(service.serviceTypes)
          ? service.serviceTypes.map(item => ({ ...service, ...item }))
          : [service])
      ], [])
      const target = expanded.find(item => !item.divider && item.value === shippingService)
      return target ? (target.text || target.value) : shippingService
    },
    isDefaultTemplate (item) {
      const defaults = this.labelTemplateDefaults || {}
      const key = {
        domestic: 'domesticTemplateId',
        export: 'exportTemplateId',
        import: 'importTemplateId'
      }[item.businessType]
      return !!key && defaults[key] === item.key
    },
    businessTypeText (type) {
      return {
        domestic: 'Domestic',
        export: 'Export',
        import: 'Import'
      }[type] || type || '-'
    }
  }
}
</script>

<style scoped>
.myDense {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelTemplateTab.vue